import { create } from "zustand";
import { useFetchReportFiltersComponentSlice } from "../slices/ReportFiltersComponentSlices/fetchReportFiltersComponent";

interface FetchReportFiltersComponentInterface
  extends ReturnType<typeof useFetchReportFiltersComponentSlice> {}

export const ReportFiltersComponentStore = create<FetchReportFiltersComponentInterface>(
  (...a) => ({
    ...useFetchReportFiltersComponentSlice(...a),
  })
);
